export interface ResendEmailVerificationProps {
  sendByDefault: boolean;
}
export interface SendVerificationError {
  response?: { data?: { message?: string } }
}
export interface SendVerificationResponse {
  sendVerificationMessage: string;
  sendVerificationSecondsLeft: number;
}

export class SendEmailVerificationError extends Error {
  response?: { data?: { message?: string } }

  constructor(message: string) {
    super(message);
    this.name = 'SendEmailVerificationError';
    this.response = { data: { message } };
  }
}
